import { Component, Input, forwardRef, ChangeDetectorRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';

import { SelectBaseComponent } from '../select-base';

@Component({
  selector: 'app-qt-select',
  templateUrl: './qt-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => QtSelectComponent),
      multi: true
    }
  ]
})
export class QtSelectComponent extends SelectBaseComponent {
  constructor(http: _HttpClient, cdr: ChangeDetectorRef) {
    super(http, cdr);
  }

  @Input() outstandingOnly: boolean = false;

  getUrl(searchValue: string): string {
    let filter = '';
    if (searchValue) {
      const searchStr = searchValue.replaceAll("'", "''");
      filter = `(contains(docCode, '${encodeURIComponent(
        searchStr
      )}') or contains(customerName,'${encodeURIComponent(searchStr)}'))`;
    }
    if (this.outstandingOnly === true) {
      if (filter) {
        filter += `and transferStatus ne 'Fully'`;
      } else {
        filter = `transferStatus ne 'Fully'`;
      }
    }
    let url = `api/quotations/lookup?$expand=currency($select=code)&$top=20&$skip=0&$orderby=docCode desc`;
    if (filter) url += `&$filter=${filter}`;
    return url;
  }
}
